<template>
  <v-app>
    <v-main class="mb-2">
      <v-card
        class="pb-2"
        style="top: 16px;margin:auto; width: 90%; height: 95%"
        :elevation=" (!isProductLoaded || $vuetify.display.xs) ? 0 : 5"
      >
        <products-pad class="pt-6 pt-sm-8 pt-md-12 px-3 px-sm-6" @loadModel="modelToLoad($event)"/>
        <viewer-menus-container
          :options="configurationOptions"
          :change-color="isQrcodeArDisplayed"
          @modelLoaded="loadOptionsItem($event)"
          @arClick="arAction()"
          @resetClick="resetAction()"
          @dimensionsClick="dimensionsAction()"
          @screenshotClick="screenshotAction()"

        />
      </v-card>
      <qr-code-ar
        v-model="isQrcodeArDisplayed"
        :url="qrcodeArUrl"
        @input="isQrcodeArDisplayed = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import scheme from './scheme/scheme'
import ProductsPad from './components/gamepad/ProductsPad.vue'
import ViewerMenusContainer from './components/ViewerMenusContainer.vue'
import QrCodeAr from './components/qrcode/QrCodeAr.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'App',

  components: {
    ProductsPad,
    ViewerMenusContainer,
    QrCodeAr,
  },

  data: () => ({
     // inspi-viewer component
     inspiViewer: null,

    // Error
    isErrorDisplayed: false,

    // Summary
    isSummaryDisplayed: false,

    // Options
    collectionOptions: null,
    configurationOptions: null,

    // Project
    isProjectCodeDisplayed: false,
    projectCode: null,

    // AR
    isQrcodeArDisplayed: false,
    qrcodeArUrl: null,
  }),

  emits: ["modelLoaded"],

  computed: {
    ...mapGetters([
        'isMenuDisplayed',
        'isProductLoaded',
        'isFrontScreenshotEnabled',
        'isProjectButtonDisplayed',
        'isArLoading'
      ]),

  },

  created () {
      console.log(scheme.title + ' version: ' + require('../package.json').version)
    },

  mounted () {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          this.attachViewerListeners(document.querySelector('#viewer-container'))
        }
      }
    },
    methods: {
      ...mapActions([
        'error',
        'setProductLoaded',
        'setProductName',
        'setProductPrice',
        'setArButtonEnabled',
        'setArLoading',
      ]),

      attachViewerListeners (viewer) {
        // An error occurred
        viewer.addEventListener('badRequest', event => {
          event.stopPropagation()
          console.log(event.detail.message)
          if (this.isArLoading) this.setArLoading(false)
          this.isErrorDisplayed = true
        })

        // The viewer has been loaded
        viewer.addEventListener('componentLoaded', event => {
          event.stopPropagation()
          this.inspiViewer = window.INSPI
        })

        // The product has been loaded
        viewer.addEventListener('INSPIFurnitureLoaded', event => {
          event.stopPropagation()
          this.setProductLoaded(true)
        })

        // Available configurations have changed
        viewer.addEventListener('APIFullConfig', event => {
          event.stopPropagation()
          this.configurationOptions = event.detail.fullconfigObject
        })

        // AR QR Code did generated successfully
        viewer.addEventListener('externalAROpening', event => {
          event.stopPropagation()
          this.setArLoading(false)
          let url = event.detail.urlQR
          if (scheme.isBeta) url += '&is_preprod=1'
          this.displayQrcodeAr(url)
        })

        // AR did launch successfully
        viewer.addEventListener('successAR', event => {
          event.stopPropagation()
          this.setArLoading(false)
        })
      },

      loadOptionsItem (element) {
        if (element.is_selected) return
        if (element.type === 'product') this.inspiViewer.loadModel({ ref: element.reference, reset_product: true })
        else this.inspiViewer.selectConfigurationAPI(element)
      },

      arAction () {
        this.setArLoading(true)
        this.inspiViewer.launchAR()
      },

      resetAction () {
        this.inspiViewer.resetView()
      },

      dimensionsAction () {
        this.inspiViewer.activateDimensions()

      },

      screenshotAction () { this.isFrontScreenshotEnabled ? this.inspiViewer.getDataURL() : this.inspiViewer.getCurrentDataURL() },

      displayQrcodeAr (url) {
        this.qrcodeArUrl = url
        this.isQrcodeArDisplayed = true
      },

      modelToLoad (model) {
        this.inspiViewer.loadModel({ ref: model, reset_product: true })
      },
    },
  }

</script>
<style>
  html, body {margin: 0; height: 100%; overflow: hidden}
</style>
